
import React, { Component } from 'react';
import Highcharts from 'highcharts'
import variablePie from "highcharts/modules/variable-pie.js";
variablePie(Highcharts);

class Chart2 extends Component {
	constructor() {
		super();
	}
	componentDidMount() {
		var colors = ['#acacac', '#8bc34a'];
		Highcharts.chart('chart_1_2', {
			chart: {
				type: 'variablepie'
			},
			title: {
				text: ''
				//   text: 'Countries compared by population density and total area.'
			},
			colors: colors,
			tooltip: {
				headerFormat: '',
				pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> {point.name}</b><br/>' +
					'Number of entries : <b>{point.y}</b> people<br/>'
				// 'Population density (people per square km): <b>{point.z}</b><br/>'
			},
			series: [{
				minPointSize: 10,
				innerSize: '20%',
				zMin: 0,
				name: 'countries',
				data: [{
					name: 'Inprogress/Unsuccess',
					y: this.props.total_invitation_sent,
					z: 66
				}, {
					name: 'Success rate ' + Math.round((this.props.total_online_success + this.props.total_tele_success) / (this.props.total_invitation_sent / 100)) + '%',
					y: this.props.total_online_success + this.props.total_tele_success,
					z: 100
				}]
			}]
		});
	}
	render() {
		return (
			<div className={"chart-box"}>
				<center>
					<div id="chart_1_2" style={{ width: "92%", height: "450px" }}></div>
				</center>
			</div>
		);
	}
}

export default Chart2;